module.exports = __webpack_public_path__ + "static/media/btn-download-iphone.d7908c10.png";